export default "__VITE_ASSET__H54oQTJ7__"